// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { BlockFragmentDoc } from '../../components/cms/CmsBlock.fragment.generated';
import { PostLinkFragmentDoc } from '../../graphql/api/cms/link.fragment.generated';
import { ImageLargeFragmentDoc } from '../../components/cms/imageLarge.fragment.generated';
import { BlogAuthorRouteFragmentDoc } from '../../graphql/api/cms/blog/fragments/blogAuthorRoute.generated';
import { BlogPostPreviewFragmentDoc } from '../../components/cms/component/blog/BlogPostPreview.generated';
import { MetaFragmentDoc } from '../../graphql/api/fragments/meta.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const BlogPostDocument = gql`
    query blogPost($slug: String!, $locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!) {
  postBySlug(slug: $slug, locale: $locale) {
    id
    title
    slug
    excerpt
    date
    blocks {
      ...block
    }
    tags(locale: $locale) {
      id
      name
      slug
    }
    author(locale: $locale) {
      id
      name
      image {
        ...imageLarge
      }
      ...blogAuthorRoute
    }
    categories(locale: $locale) {
      id
      name
      slug
    }
    relatedPosts(limit: 3, locale: $locale) {
      ...blogPostPreview
    }
    ...postLink
    meta {
      ...meta
    }
  }
}
    ${BlockFragmentDoc}
${ImageLargeFragmentDoc}
${BlogAuthorRouteFragmentDoc}
${BlogPostPreviewFragmentDoc}
${PostLinkFragmentDoc}
${MetaFragmentDoc}`;

export function useBlogPostQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.BlogPostQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.BlogPostQuery, SchemaTypes.BlogPostQueryVariables | undefined>({ query: BlogPostDocument, variables: undefined, ...options });
};